export function numberToWords(num) {
  if (!num) return "";

  // اگر ورودی ریال است → به تومان تبدیل می‌کنیم
  num = Math.floor(num / 10);

  const th = ["", " هزار", " میلیون", " میلیارد"];
  const dg = ["صفر","یک","دو","سه","چهار","پنج","شش","هفت","هشت","نه"];
  const tn = ["ده","یازده","دوازده","سیزده","چهارده","پانزده","شانزده","هفده","هجده","نوزده"];
  const tw = ["","ده","بیست","سی","چهل","پنجاه","شصت","هفتاد","هشتاد","نود"];
  const hg = ["","یکصد","دویست","سیصد","چهارصد","پانصد","ششصد","هفتصد","هشتصد","نهصد"];

  num = num.toString().replace(/,/g, "");

  if (isNaN(num)) return "";

  const arr = [];

  while (num.length > 0) {
    arr.push(num.slice(-3));
    num = num.slice(0, -3);
  }

  let words = arr
    .map((chunk, index) => {
      if (Number(chunk) === 0) return "";

      const c = String(Number(chunk)).padStart(3, "0");
      const h = hg[c[0]];
      const t = c[1];
      const u = c[2];

      let str = h;

      if (t === "1") {
        str += (h ? " و " : "") + tn[u];
      } else {
        if (t > 1) str += (h ? " و " : "") + tw[t];
        if (u > 0)
          str += (h || t > 0 ? " و " : "") + dg[u];
      }

      return str + th[index];
    })
    .filter(Boolean)
    .reverse()
    .join(" و ");

  return words + " تومان";
}
